import * as React from 'react';
import copy from 'clipboard-copy';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Tooltip from '@material-ui/core/Tooltip';
import { createStyles, IconButton, Theme, withStyles, WithStyles } from '@material-ui/core';
import { I18nextProps } from '@pec/aion-ui-i18next/types/i18n';
import { withTranslation } from 'react-i18next';

type OwnProps = {
  valueToCopy: string;
};

interface OwnState {
  showTooltip: boolean;
}

const styles = (theme: Theme) =>
  createStyles({
    copyButton: {
      fontSize: 16,
      color: theme.palette.text.secondary
    },
    button: {
      padding: theme.spacing(0, 1)
    }
  });

type Props = WithStyles<typeof styles> & OwnProps & I18nextProps;

class CopyToClipboardComponent extends React.Component<Props, OwnState> {
  state: OwnState = { showTooltip: false };
  render() {
    const { classes, valueToCopy, t } = this.props;
    return (
      <Tooltip
        open={this.state.showTooltip}
        title={t('components.copyToClipboard.correlationIdCopied', 'Correlation ID copied to clipboard') || ''}
        leaveDelay={1000}
        onClose={this.handleOnTooltipClose}
      >
        <IconButton className={classes.button} onClick={() => this.onCopy(valueToCopy)}>
          <FileCopyIcon className={classes.copyButton} />
        </IconButton>
      </Tooltip>
    );
  }

  onCopy = (content: string) => {
    copy(content);
    this.setState({ showTooltip: true });
  };

  handleOnTooltipClose = () => {
    this.setState({ showTooltip: false });
  };
}

export const CopyToClipboard = withStyles(styles)(withTranslation()(CopyToClipboardComponent));
